module.exports = __webpack_public_path__ + "static/media/meettheteam.57debe62.jpg";